import styled from 'styled-components';

export const DropdownAvatarImg = styled.img`
  background: var(--grey-200);
  border-radius: 50%;
  height: 36px;
  margin-right: 14px;
  margin-top: 2px;
  object-fit: cover;
  width: 36px;
`;

export const DropdownItem = styled.div`
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  padding: 12px 16px;
  position: relative;

  &:hover {
    background: var(--grey-150);
  }

  /* Divider between items */
  &:not(:last-child)::after {
    background: var(--grey-200);
    bottom: 0;
    content: '';
    height: 1px;
    left: 0;
    opacity: 0.7;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
`;

export const DropdownItemContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const DropdownItemText = styled.div`
  color: var(--black);
  font-family: var(--open-sans);
  font-size: 14px;
  line-height: 1.4;
`;

export const DropdownItemTime = styled.time`
  color: var(--grey-500);
  font-size: 14px;
  margin-top: 4px;
`;

export const DropdownItemTitle = styled.div`
  color: var(--grey-blue-400);
  font-family: var(--open-sans);
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 2px;
`;

export const DropdownItemPreview = styled.div`
  -webkit-box-orient: vertical;
  color: var(--grey-500);
  display: -webkit-box;
  font-size: 14px;
  -webkit-line-clamp: 2;
  line-height: 1.3;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Menu "tail"/arrow that points upward
export const Tail = styled.div`
  height: 18px;
  overflow: hidden;
  position: absolute;
  right: 30px;
  top: -18px;
  width: 25px;

  &::before {
    background-color: var(--white);
    box-shadow: var(--shadow-lg);
    content: '';
    display: block;
    height: 16px;
    left: 4px;
    position: absolute;
    rotate: 45deg;
    top: 10px;
    width: 16px;
  }
`;

export const DropdownArrow = styled.span`
  align-items: center;
  color: var(--grey-600);
  display: flex;
  font-size: 8px;
  pointer-events: none;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
`;

export const FooterLink = styled.div`
  & a {
    color: inherit;
    display: block;
    text-decoration: none;
  }
`;

export const FooterBar = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const DropdownMenu = styled.div`
  background: var(--white);
  border-radius: 5px;
  box-shadow: var(--shadow-lg);
  min-width: 200px;
  position: absolute;
  right: -24px;
  top: calc(100% + 15px);
  z-index: 1000;
`;

export const DropdownMenuItem = styled.button`
  align-items: center;
  background: none;
  border: none;
  color: var(--grey-600);
  cursor: pointer;
  display: flex;
  font-family: var(--open-sans);
  font-size: 13px;
  gap: 10px;
  padding: 12px 16px;
  text-align: left;
  width: 100%;

  &:hover {
    background: var(--grey-150);
    color: var(--wbs-red);
  }
`;

export const MenuIcon = styled.span`
  align-items: center;
  display: flex;
  font-size: 13px;
  justify-content: center;
  width: 16px;
`;

export const ChevronIcon = styled.span`
  color: var(--grey-500);
  font-size: 9px;
  margin-left: 6px;
`;
